import { Injectable } from '@angular/core';
import { gql } from '@apollo/client';
import { Query } from 'apollo-angular';

import { DeliveryType } from '../enums/delivery-type.enum';
import { InventoryProductItem } from '../models/inventory-product-item.model';
import { InventoryStatusItem } from '../models/inventory-status-item.model';

export interface InventoryStatusQueryResponse {
  inventory: {
    languageCode: string;
    storeSapId: string;
    items: InventoryStatusItem[];
  };
}

export interface InventoryStatusQueryVariables {
  inventory: {
    deliveryType: DeliveryType;
    storeSapId: string;
    languageCode: string;
    requestedFromDate: string;
    requestedToDate: string;
    items: InventoryProductItem[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class B2BInventoryStatusQuery extends Query<InventoryStatusQueryResponse, InventoryStatusQueryVariables> {
  override document = gql`
    query ($inventory: GetInventoryQueryInput) {
      inventory(inventoryQuery: $inventory) {
        languageCode
        storeSapId
        items {
          itemNumber
          sKU
          exportCatalogSKU
          inventoryStatus
          inventoryComment
        }
      }
    }
  `;
}
